import React from 'react';

export default function CTA() {
  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-12 mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center items-start mx-auto">
          <h2 className="flex-grow sm:pr-16 text-2xl font-medium title-font text-gray-900">
            ¡Participa en el VI congreso SVRID 2025!
          </h2>
          <a
            // href="https://eventusvip.com/svrid/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 text-white bg-blue-500 border-0 py-2 px-8 focus:outline-none hover:bg-blue-600 rounded text-lg mt-10 sm:mt-0 mr-4"
          >
            Inscripción General
          </a>
          <a
            // href="https://eventusvip.com/svrid/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 text-white bg-blue-500 border-0 py-2 px-8 focus:outline-none hover:bg-blue-600 rounded text-lg mt-10 sm:mt-0"
          >
            Inscripción Estudiantes
          </a>
        </div>
      </div>
    </section>
  );
}
